export default __webpack_public_path__ + "src/images/packages/the-coconut-shell/3517a1ea97f91b31e4adacc09ab56091-3.jpg";